module.exports = __webpack_public_path__ + "assets/img/27_1347_big.d485a914.jpg";